import React, { useEffect, useState } from 'react';
import IncrementButton from '../../../../../../atomic/buttons/incrementButton/IncrementButton';
import style from './ExitTacticsContainer.module.css';
import { colors } from '../../../../../../../colorVars';
import ModuleWrapper from '../moduleWrapper/ModuleWrapper';
import PropTypes from 'prop-types';

const tacticList = [
  'Loss Limit',
  'Preserve Profit',
  'Underlying Price Trail',
  'Position Price Trail',
  'Candle Trail',
  'Grab Cents',
  'Ratchet Bracket',
  'Green To Red Candles',
  'Green To Red Positions',
  'Underlying Break Price',
  'Candle Magnitude',
  'Atr Trail',
  'Mfe Retracement',
  'Underlying Price Exit',
  'Position Break Price',
];
const ExitTacticsContainer = (props) => {
  const [currentSelection, setCurrentSelection] = useState('default');
  const [moduleList, setModuleList] = useState([]);
  const [optionSelected, setOptionSelected] = useState(false);
  const addTactic = () => {
    if (moduleList.includes(currentSelection) || currentSelection === 'default')
      return;
    setModuleList((prevState) => [...prevState, currentSelection]);
    setCurrentSelection('default');
  };
  const removeTactic = (index) => {
    const newArr = [...moduleList];
    newArr.splice(index, 1);
    setModuleList(newArr);
  };
  const camelToCapitalized = (string) => {
    const result = string.replace(/([A-Z])/g, ' $1');
    return result.charAt(0).toUpperCase() + result.slice(1);
  };
  const updateModuleList = () => {
    const filteredArr = Object.keys(props).filter(
      (item) => item !== 'top' && props[item][2] === true
    );
    const capitalizedArr = filteredArr.map((item) => {
      if (item === 'breakPrice') return 'Underlying Break Price';
      else return camelToCapitalized(item);
    });
    setModuleList(capitalizedArr);
  };
  const checkTop = () => {
    if (props.top.instrument === 'option') setOptionSelected(true);
    else {
      setOptionSelected(false);
      const result = moduleList.findIndex(
        (item) => item === 'Underlying Price Trail'
      );
      if (result !== -1) removeTactic(result);
      const result2 = moduleList.findIndex(
        (item) => item === 'Position Break Price'
      );
      if (result2 !== -1) removeTactic(result2);
    }
  };

  useEffect(() => {
    checkTop();
    return () => {};
  }, [props.top.instrument]);

  useEffect(() => {
    updateModuleList();
  }, [props]);

  return (
    <div className={style.container}>
      <div className={style.addTactic}>
        <select
          className={style.input}
          value={currentSelection}
          onChange={({ target }) => setCurrentSelection(target.value)}
        >
          <option value="default">Select exit tactic...</option>
          {tacticList.map((tactic) => {
            if (
              !optionSelected &&
              (tactic === 'Underlying Price Trail' ||
                tactic === 'Position Break Price')
            )
              return;
            else
              return (
                <option key={tactic} value={tactic}>
                  {tactic}
                </option>
              );
          })}
        </select>
        <IncrementButton
          width={10}
          color="white"
          backgroundColor={colors.blue}
          paddingPercent={30}
          stroke={2}
          handleClick={addTactic}
        />
      </div>
      <div>
        {moduleList.map((module, index) => (
          <ModuleWrapper
            key={module}
            index={index}
            type={module}
            removeTactic={removeTactic}
            stateProps={props}
          />
        ))}
      </div>
    </div>
  );
};
ExitTacticsContainer.propTypes = {
  top: PropTypes.object.isRequired,
};
export default ExitTacticsContainer;
